/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileSubscription } from '../../models/profile-subscription';

export interface GetUserActiveSubscriptions$Params {

/**
 * Id of user.
 */
  id: number;
}

export function getUserActiveSubscriptions(http: HttpClient, rootUrl: string, params: GetUserActiveSubscriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileSubscription>>> {
  const rb = new RequestBuilder(rootUrl, getUserActiveSubscriptions.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileSubscription>>;
    })
  );
}

getUserActiveSubscriptions.PATH = '/rest/user/{id}/profile/subscriptions';
